import React from "react";

class OrganicHeader extends React.Component {
  render() {
    const {
      organicHeaderH1,
      organicHeaderDesc,
      organicHeaderTextWidth,
      organicHeaderColor,
      organicHeaderCustomClass,
      organicHeaderCustomBgPosition
    } = this.props;
    return (
      <header
        className={`shape-based-header ${organicHeaderCustomClass} ${organicHeaderColor}`}
        style={organicHeaderCustomBgPosition}
      >
        <div className="container shape-based-header--message">
          <div className={`full restrict ${organicHeaderTextWidth}`}>
            <h1>{organicHeaderH1}</h1>
            {<p className="desc">{organicHeaderDesc}</p>}
          </div>
          {/* /.full /.restrict /.narrow */}
        </div>
        {/* /.container /.shape-based-header  */}
      </header>
    );
  }
}
export default OrganicHeader;
